import Axios from 'axios';
import { apiUrl } from 'app/environment-variables';
import { InsightsI } from './models';

export type BaseParams = {
  [param: string]: unknown;
};

export type PaginationParams = {
  limit?: number;
  offset?: number;
};

type InsightParams = {
  page_url__icontains: string;
};

export const getInsights = (params?: BaseParams & PaginationParams) =>
  Axios.get<CommonTypes.RestfulResponse<InsightsI>>(`${apiUrl}/insights`, {
    params,
  });

export const getInsight = (params: InsightParams) =>
  Axios.get<CommonTypes.RestfulResponse<InsightsI>>(`${apiUrl}/insights/`, {
    params,
  });
